import { Injectable } from '@angular/core';
import { NullableTraceDatum } from '@dashboard/dashboard-library/types/map.types';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RxjsStateService {
  private _trace$ = new BehaviorSubject<NullableTraceDatum[]>([]);

  constructor() {}

  public setTrace(trace: NullableTraceDatum[]) {
    this._trace$.next(trace);
  }
  public get trace$() {
    return this._trace$.asObservable();
  }

  public updateTracePoint(position: NullableTraceDatum) {
    const trace = this._trace$.getValue();

    if (!trace || trace.length == 0) return [];

    this._trace$.next([...trace, position]);
  }
}
